// extracted by mini-css-extract-plugin
export default {"root":"Sidebar__root--Ie8E4","show":"Sidebar__show--FQsOm","logo":"Sidebar__logo--CMjut","links":"Sidebar__links--aNaDp"};